import { Component, EventEmitter, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuService } from '../../services/menu.service';
import { AuthService } from '../../services/auth.service';
import { SMCService } from '../../services/smc.service';
import { DynamicSQLGridComponent } from '../admin-components/admin-grids/dynamic-sql-grid/dynamic-sql-grid.component';
import { LoggingService } from 'src/app/services/logging.service';
import { TabEntryComponent } from '../admin-components/hourglass/tab-entry/tab-entry.component';
import { HourglassService } from 'src/app/services/hourglass.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, OnDestroy {
  @ViewChild(DynamicSQLGridComponent) childComponent!: DynamicSQLGridComponent;
  @ViewChild(TabEntryComponent) timeEntryComponent!: TabEntryComponent;

  menuItems: any[] = [];
  groupedMenuItems: any = {};
  username: string | null = null;
  useremail: string | null = null;
  welaraid: number | null = null;
  isAdmin = false;
  isSidebarOpen = true;
  isSubnavAdminOpen = false;
  showModal: 'none' | 'block' = 'none';
  dateStamp: string | null = null;
  userRole: number | null = null;
  profilePic: SafeUrl = '';
  showSessionWarningModal = false;
  private sessionWarningSub?: Subscription;

  warningSecondsRemaining = 0;
  private warningSecondsSub?: Subscription;

  tokenExpires = "";
  smcCounter = 0;

  constructor(
    private authService: AuthService,
    private smcService: SMCService,
    private hourglassService: HourglassService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private menuService: MenuService,
    private loggingService: LoggingService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    $('body,.sidebar').css({ "background-color": "var(--welaratimberwolf)" });

    //this.authService.startIdleWatch();
    setTimeout(() => {
      const u: any = parseInt(sessionStorage.getItem('wOSAuthUser') || '0');
      const tok: any = JSON.parse(sessionStorage.getItem('wOSUser') || '{}').stsTokenManager.accessToken;

      this.authService.startIdleWatch();
      this.smcService.getInbox(u, tok).then(inbox => {
        console.log("Inbox on init", inbox);
        this.smcCounter = inbox.messages.length;
      }).catch(err => console.error("Error fetching inbox on init", err));
    }, 750);

    this.authService.getUserRole().subscribe(role => {
      this.userRole = (role == 0) ? 2 : role; // if the role assignment comes back as zero, its a client
      if(this.userRole == 2)
        sessionStorage.setItem("wOSUserRole", this.userRole.toString());
      //console.log("User Role", this.userRole);
    });

    const user: any = sessionStorage.getItem('wOSUser');
    const token = JSON.parse(user).stsTokenManager.accessToken;
    const photo: any = JSON.parse(sessionStorage.getItem('wOSUser') || '').photoURL;


    this.profilePic = (photo == null) ? '' : this.getSafeUrl(photo);
    //console.log("Profile pic",this.profilePic)

    this.menuService.getMenuData(token).subscribe(
      data => {
        this.groupMenuData(data);
        this.dateStamp = Date.now().toString();
      },
      error => {
        console.error('Error fetching menu data:', error);
      }
    );

    this.authService.getUsername().subscribe(username => {
      this.username = username;
      const key: string | null = sessionStorage.getItem('wOSUser');
      if (key !== null && token) {
        const json = JSON.parse(key);
        this.hourglassService.getUserMetadataEmail(json.email, token).then(r => {
          sessionStorage.setItem('wOSAdmin', r[0].admin);
          sessionStorage.setItem('wOSAuthUser', r[0].id);
          sessionStorage.setItem('wOSTimezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
          sessionStorage.setItem('wOSUserPrefs', JSON.stringify(r[0]));
        });
      }
    });

    this.sessionWarningSub = this.authService.sessionWarning$.subscribe(show => {
      this.showSessionWarningModal = show;
    });

    this.warningSecondsSub = this.authService.warningSecondsRemaining$.subscribe(secs => {
      this.warningSecondsRemaining = secs;
    });
  }

  ngOnDestroy(): void {
    this.sessionWarningSub?.unsubscribe();
    this.warningSecondsSub?.unsubscribe();
    this.authService.stopIdleWatch();
  }

  extendSession(): void {
    this.authService.extendSession();
  }

  logoutFromWarning(): void {
    this.logout();
  }

  formatSeconds(totalSeconds: number): string {
    const secs = Math.max(0, totalSeconds);
    const minutes = Math.floor(secs / 60);
    const remainingSeconds = secs % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  dismissSessionWarning(): void {
    this.authService.clearSessionWarning();
  }

  gotoMsgCenter(): void {
    this.router.navigate(['/smc']);
  }

  toggleSubnav(): void {
    this.isSubnavAdminOpen = !this.isSubnavAdminOpen;
  }

  toggleSidebar(): void {
    this.loggingService.log(`Sidebar toggled: ${this.isSidebarOpen ? 'Open' : 'Closed'}`);
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  getCategoryIds(): string[] {
    return Object.keys(this.groupedMenuItems);
  }

  groupMenuData(data: any): void {
    this.loggingService.log(`Grouping menu data (${data.length} items received).`);

    const grouped: { [key: string]: any } = {};

    data.forEach((item: any) => {
      if (!grouped[item.menu_category_id]) {
        grouped[item.menu_category_id] = {
          categoryName: item.menu_category_name,
          categoryIcon: item.menu_category_icon_data,
          categoryOrder: item.menu_category_order,
          items: []
        };
      }
      grouped[item.menu_category_id].items.push(item);
    });

    this.groupedMenuItems = Object.values(grouped).sort(
      (a: any, b: any) => a.categoryOrder - b.categoryOrder
    );
  }

  toggleCategories(show: boolean | null = null): void {
    this.loggingService.log(`Toggling categories: ${show ? 'Expanded' : 'Collapsed'}`);
    if (!show) {
      $('.sidebar .collapse').removeClass('show');
    } else {
      $('.sidebar .collapse').addClass('show');
    }
  }

  getSafeUrl(content: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(content);
  }

  logout(): void {
    this.loggingService.log('User logging out.');
    sessionStorage.removeItem('wOSAdmin');
    sessionStorage.removeItem('wOSAuthUser');
    sessionStorage.removeItem('wOSImpersonate');
    sessionStorage.removeItem('wOSTimezone');
    sessionStorage.removeItem('wOSUserPrefs');

    this.router.navigate(['login']);
    this.authService.logout().subscribe();
  }
}
